import React, { useState } from 'react';
import styles from './bomManage.module.css';
import { Upload } from '../../../Svg';
import QuotePopup from '../../components/OtherComps/QuotePopup/QuotePopup';
import * as XLSX from "xlsx";
import { exportDataExcel, handleFileUpload } from '../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { deletBomPreviewData, deleteInputValue, setBomPreview, setFileName, setInputValue } from '../../redux/bomSlice';
import { useNavigate } from 'react-router-dom';

const BomManage = () => {
  const { bompreview, filename, inputValue } = useSelector((state) => state.bom)
  const [selectedFile, setFile] = useState(null)
  const [activeTab, setActiveTab] = useState('fileUpload');
  const tabs = ['fileUpload', 'copypaste'];
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [productData, setProductData] = useState([]);

  const checkInput = inputValue?.split(',')
  const dispacth = useDispatch()
  const navigate = useNavigate()

  const openPopup = () => {
    setPopupOpen(true);
  };

  const closePopup = () => {
    setPopupOpen(false);
  };


  // const handleFileUpload = (e) => {
  //   const file = e.target.files[0];
  //   setFile(file)
  //   dispacth(setFileName(file))
  //   if (file) {
  //     const reader = new FileReader();

  //     reader.onload = (event) => {
  //       const binaryStr = event.target.result;
  //       const workbook = XLSX.read(binaryStr, { type: "binary" });
  //       const sheetName = workbook.SheetNames[0];
  //       const sheet = workbook.Sheets[sheetName];
  //       const jsonData = XLSX.utils.sheet_to_json(sheet);
  //       console.log(jsonData);

  //       dispacth(setBomPreview(jsonData))
  //     };

  //     reader.readAsBinaryString(file);
  //   }
  // };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    setFile(file);
    dispacth(setFileName(file));

    if (file) {
      const reader = new FileReader();

      reader.onload = (event) => {
        const binaryStr = event.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        // Get raw array of rows (2D array)
        const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        let jsonData = data.filter((item) => item.length > 0);

        console.log("jsonData---", jsonData)

        // Dynamically assign column keys like column0, column1, etc.
        const normalizedData = jsonData.map((row, index) => {
          const rowObject = { id: index + 1 };
          row.forEach((cell, colIndex) => {
            rowObject[`column${colIndex}`] = cell;
          });
          return rowObject;
        });

        console.log("Normalized Raw Data:", normalizedData);
        dispacth(setBomPreview(normalizedData));
      };

      reader.readAsBinaryString(file);
    }
  };




  const handlePreview = () => {

    navigate(`/fileUploadPreview`, { state: { data: bompreview, from: 'bom' } })
  };


  const downloadtemplate = () => {
    const data = [
      {
        productNumber: "",
        quantity: "",
        manufacturer: ""
      }
    ]
    exportDataExcel(data, 'bomenquiry')
  }




  const handleSubmit = (e) => {
    e.preventDefault();
    // Convert input string into an array of objects
    const values = inputValue.split(",");
    const products = [];

    for (let i = 0; i < values.length; i += 3) {
      if (values[i] && values[i + 1] && values[i + 2]) {
        products.push({
          productNumber: values[i].trim(),
          quantity: values[i + 1].trim() || 1,
          manufacturer: values[i + 2].trim() || '',
        });
      }
    }
    // const serializedData = encodeURIComponent(JSON.stringify(products));
    // navigate(`/fileUploadPreview?data=${serializedData}`);
    navigate(`/fileUploadPreview`, { state: { data: products, from: 'bom' } })

  };

  return (
    <>
      <div className={styles.imgBread}>
        <span>BOM management</span>
      </div>
      <div className={styles.bomcontainer}>
        <div className={styles.bomTabsCol1}>
          {/* Tabs Section */}
          <div className={styles.bomtabs}>
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`${styles.bomtabButton} ${activeTab === tab ? styles.active : ''}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab === 'fileUpload' && 'File Upload'}
                {tab === 'copypaste' && 'Copy & Paste'}
              </button>
            ))}
          </div>

          {/* Table Section */}
          {activeTab === 'fileUpload' && (
            <div className={styles.displayFlex}>
              <div className={styles.bomContentBox}>
                <p>Choose the file and sheet to upload. At minimum you will need to include part numbers and quantities for each.</p>
                <h3>File Upload</h3>
                <label htmlFor="doc">
                  <div className={styles.bomInnerBox} style={{ cursor: 'pointer' }}>
                    <Upload />
                    {filename ?
                      <span>{filename?.name}</span>
                      :
                      <span>Choose the file and sheet to upload</span>
                    }
                    <div className={styles.chooseBtn}>Choose File</div>
                    <input
                      id='doc'
                      type="file"
                      accept=".xlsx, .xls"
                      onChange={handleFileUpload}
                      style={{ display: 'none' }}
                    />
                  </div>
                </label>
                <span>We support .xls, .xlsx and .csv files under 4MB</span>
                <div className={styles.displayFlex2}>
                  <button className={styles.cancelBtn} onClick={() => dispacth(deletBomPreviewData())}>Cancel</button>
                  <button className={styles.submitBtn}
                    onClick={handlePreview}
                    disabled={bompreview?.length <= 0}
                    style={{ background: bompreview?.length <= 0 ? '#8463d1' : '#512DA8' }}
                  >
                    Submit
                  </button>
                </div>
              </div>
              <div className={styles.bomTabsCol2}>
                <p>Submit part numbers in bulk by uploading your spreadsheet or copying and pasting them here.
                  File Upload Steps:
                  <ol>
                    <li>Upload your spreadsheet.</li>
                    <li> Map the required data columns.</li>
                    <li> Purchase your parts, get a quote or add them to a project list.</li>
                  </ol>
                </p>
                <div onClick={downloadtemplate} className={styles.download} style={{ cursor: 'pointer' }}>Download our BOM template</div>
              </div>
            </div>
          )}
          {activeTab === 'copypaste' && (
            <div className={styles.displayFlex}>
              <div className={styles.bomContentBox}>
                <p> Please paste part data in this format with one part per line:
                  Part Number, Quantity, Your Part Number, PO Number</p>
                <h3> Copy & Paste</h3>
                <div>
                  <textarea
                    value={inputValue}
                    onChange={(e) => dispacth(setInputValue(e.target.value))}
                    placeholder="Ex: Mypartnumber, quantity, manufacturer&#10;NextPartNumber, quantity, manufacturer"
                    className={styles.bomInnerBox2}
                  />
                </div>
                <span>Copy & paste your BOM information</span>
                <div className={styles.displayFlex2}>
                  <button className={styles.cancelBtn} onClick={() => dispacth(deleteInputValue())}>Cancel</button>
                  <button
                    className={styles.submitBtn}
                    onClick={handleSubmit}
                    disabled={checkInput?.length < 3}
                    style={{ background: checkInput?.length < 3 ? '#8463d1' : '#512DA8' }}
                  >
                    Submit
                  </button>
                  {/* <button className={styles.submitBtn} onClick={openPopup}>Add to list</button> */}
                  {isPopupOpen && <QuotePopup onClose={closePopup} />}
                </div>
              </div>
              <div className={styles.bomTabsCol2}>
                <p>
                  <span> Copy-And-Paste Steps:</span> <br />
                  <ol>
                    <li>Copy/paste part data from your spreadsheet to the text box</li>
                    <li> Purchase your parts, get a quote or add them to a project list.</li>
                    <li> Example:                  DWP-125-3/8-0-STK, 4, MyPartNumber1, PO1234 0008500113, 20000, MyPartNumber2, PO1234 CL1F2101, 1, MyPartNumber3, PO1234</li>
                  </ol>
                </p>
              </div>
            </div>
          )}
        </div>

      </div >
    </>
  );
};

export default BomManage;
